import * as yup from 'yup';
import YupValidationErrors from '@/Utils/YupValidationErrors';
import { extractTextWithNewLinesFromHtml } from '../../../../../Assessments/Modify/Steps/JobAdStep/JobAdStepUtils';

export const ApplicantResultsNoteLengthLimit = 1250;

const noteValidationScheme = yup.object({
    noteRte: yup
        .string()
        .defined()
        .test(
            'TooLong',
            YupValidationErrors.RecruitersNoteInputLengthValidation(ApplicantResultsNoteLengthLimit),
            (value) => {
                const plainText = extractTextWithNewLinesFromHtml(value || '');
                return plainText.length <= ApplicantResultsNoteLengthLimit;
            },
        ),
});

export type CandidatesNoteForm = yup.InferType<typeof noteValidationScheme>;

export default noteValidationScheme;
